import { ITableCols } from '../types';

import { StrikeReportRow } from './strike-report-data-rows';

export const isColumnEmpty = (colId: string, rows: StrikeReportRow[]): boolean => {
  const checkRow = (row: StrikeReportRow): boolean => {
    if (row.values[colId] !== null && row.values[colId] !== undefined) {
      return false;
    }
    if (row.children && row.children.length > 0) {
      return row.children.every(checkRow);
    }
    return true;
  };
  return rows.every(checkRow);
};

export const filterEmptyExpiries = (
  columns: ITableCols[],
  rows: StrikeReportRow[],
  display: string[],
): ITableCols[] => {
  if (display.includes('emptyExpiries')) {
    return columns;
  }
  return columns.filter((col) => !isColumnEmpty(col.id, rows));
};

export const isRowEmpty = (row: StrikeReportRow): boolean => {
  const hasValue = Object.values(row.values).some((val) => val !== null && val !== undefined);
  if (hasValue) return false;
  if (!row.children || row.children.length === 0) return true;
  return row.children.every(isRowEmpty);
};

export const filterEmptyStrikes = (
  rows: StrikeReportRow[],
  display: string[],
): StrikeReportRow[] => {
  if (display.includes('emptyStrikes')) {
    return rows;
  }
  return rows
    .map((row) => {
      const filteredChildren = row.children ? filterEmptyStrikes(row.children, display) : [];
      const newRow = { ...row, children: filteredChildren };
      return isRowEmpty(newRow) ? null : newRow;
    })
    .filter((r) => r !== null) as StrikeReportRow[];
};
